import React from 'react';
import { X, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface WeatherForecastModalProps {
  isOpen: boolean;
  onClose: () => void;
  lat: number;
  lon: number;
}

const WeatherForecastModal: React.FC<WeatherForecastModalProps> = ({
  isOpen,
  onClose,
  lat,
  lon
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  // Bruker dark mode fra Yr siden Fricamp er dark
  const yrUrl = `https://www.yr.no/nb/innhold/${lat.toFixed(4)},${lon.toFixed(4)}/card.html?mode=dark`;
  const yrExternalUrl = `https://www.yr.no/nb/værvarsel/daglig-tabell/${lat.toFixed(4)},${lon.toFixed(4)}`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div
        className="relative w-full max-w-sm h-[500px] bg-[var(--bg-card)] rounded-2xl shadow-xl overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-[var(--border-color)] shrink-0">
          <h2 className="text-lg font-bold text-[var(--text-primary)]">
            {t('weather.forecast', 'Værvarsel')}
          </h2>
          <button
            onClick={onClose}
            className="p-2 -mr-2 rounded-full hover:bg-[var(--bg-secondary)] text-[var(--text-secondary)] transition-colors"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="flex-1 overflow-auto">
          <iframe
            src={yrUrl}
            title={t('weather.forecast', 'Værvarsel')}
            className="w-full h-full border-0"
            sandbox="allow-scripts allow-same-origin"
          />
        </div>
        
        <div className="p-3 bg-[var(--bg-secondary)] border-t border-[var(--border-color)] flex justify-between items-center text-sm shrink-0">
          <span className="text-[var(--text-muted)]">
            Levert av <a href="https://www.yr.no/" target="_blank" rel="noopener noreferrer" className="text-sky-400 hover:underline">Yr</a>
          </span>
          
          <a 
            href={yrExternalUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1.5 text-sky-400 font-medium hover:text-sky-300 transition-colors"
          >
            Se mer på Yr <ExternalLink size={14} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default WeatherForecastModal;
